export let ShopifyAppStatus = /*#__PURE__*/function (ShopifyAppStatus) {
  ShopifyAppStatus["INSTALLED"] = "INSTALLED";
  ShopifyAppStatus["UNINSTALLED"] = "UNINSTALLED";
  return ShopifyAppStatus;
}({});
export let ShopifyAppStatusMapped = /*#__PURE__*/function (ShopifyAppStatusMapped) {
  ShopifyAppStatusMapped["INSTALLED"] = "Installed";
  ShopifyAppStatusMapped["UNINSTALLED"] = "Uninstalled";
  return ShopifyAppStatusMapped;
}({});
export let SHOPIFY_STORES_STATUS = /*#__PURE__*/function (SHOPIFY_STORES_STATUS) {
  SHOPIFY_STORES_STATUS["ALL"] = "ALL";
  SHOPIFY_STORES_STATUS["Installed"] = "INSTALLED";
  SHOPIFY_STORES_STATUS["Uninstalled"] = "UNINSTALLED";
  return SHOPIFY_STORES_STATUS;
}({});